import React from 'react';
import { useIntl } from 'react-intl';

import Icon from 'app/components/Icon';
import Button from 'app/components/Button';
import usePaymentMethodsContext from 'app/modules/MyAccount/pages/PaymentMethods/context/PaymentMethodsContext';
import { Colors } from 'app/utils/colors';
import logo from 'app/assets/png/paypal-logo.png';

export default function EmptyPayPal() {
  const intl = useIntl();

  const { handleGoToPayPalForm } = usePaymentMethodsContext();

  return (
    <div className="bb-payment-methods-paypal__empty">
      <div className="bb-payment-methods-paypal__empty__name">
        <img src={logo} alt="PayPal" width="75.86px" height="19.95px" />
        <p className="bb-payment-methods-paypal__p-info medium">
          {intl.formatMessage({
            id: 'controlpanel.payment_methods.paypal_details.no_account'
          })}
        </p>
      </div>
      <Button
        text={intl.formatMessage({
          id: 'controlpanel.payment_methods.paypal_details.add_button'
        })}
        type="secondary"
        size="big"
        typeButton="button"
        onClick={handleGoToPayPalForm}
        iconRight={
          <Icon
            icon="arrow-up-right-from-square"
            size="lg"
            swapOpacity
            color={Colors.bbWhite}
          />
        }
      />
    </div>
  );
}
